import React from "react";
import ReactDOM from "react-dom";
import App from "./docs/App";
import * as serviceWorker from "./serviceWorker";
import router, { history } from "./docs/router/router";

const renderApp = (location: string) => {
  router
    .resolve(location)
    .then((component) =>
      ReactDOM.render(<App>{component}</App>, document.getElementById("root"))
    );
};

// Render page when path changes.
history.listen(() => renderApp(window.location.pathname));

// Render page the first time.
renderApp(window.location.pathname);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
